import { decisionLog } from "./decision-log";
import { institutionalMemory } from "./institutional-memory";
import { orgtoolsVsAlternatives } from "./orgtools-vs-alternatives";
import { orgtoolsVsAsana } from "./orgtools-vs-asana";
import { orgtoolsVsCascade } from "./orgtools-vs-cascade";
import { orgtoolsVsQuantive } from "./orgtools-vs-quantive";
import { strategicDrift } from "./strategic-drift";
import type { Article, ArticleKind } from "./types";

export const ARTICLES: readonly Article[] = [
  strategicDrift,
  decisionLog,
  institutionalMemory,
  orgtoolsVsAlternatives,
  orgtoolsVsAsana,
  orgtoolsVsQuantive,
  orgtoolsVsCascade,
];

export const GUIDES: readonly Article[] = ARTICLES.filter((article) => article.kind === "guide");

export const COMPARISONS: readonly Article[] = ARTICLES.filter(
  (article) => article.kind === "comparison",
);

export function getArticle(kind: ArticleKind, slug: string): Article | undefined {
  return ARTICLES.find((article) => article.kind === kind && article.slug === slug);
}
